import React from 'react';
import usePageTitle from 'Routes/Overrides/routes/MerchantOverrides/hooks/usePageTitle';
import RulesHeader from 'Components/RulesHeader';
import DeployedInfoText from 'Components/DeployedInfoText';

const Header = () => {
    const pageTitle = usePageTitle();
    return (
        <RulesHeader>
            <RulesHeader.Left title={pageTitle} isSandbox={false} isMerchant />
            <RulesHeader.Right>
                <DeployedInfoText isLandlordDeployment={false} />
            </RulesHeader.Right>
        </RulesHeader>
    );
};

export default Header;
